/*
 * Ryan O'Dowd
 * 2025-06-11
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import FormControl from '@components/common/FormControl';
import Icon from '@react-native-vector-icons/material-design-icons';
import Menu from '@components/common/Menu';
import Text from '@components/common/Text';
import {
  TouchableRipple,
} from 'react-native-paper';
// @TODO: import TextInput from '@components/common/TextInput';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const Select = (props: SelectProps) => {
  const styles = hooks.useStyles(getStyles);

  const [_isOpen, setIsOpen] = useState(false);
  const [_menuWidth, setMenuWidth] = useState(undefined);

  const selectedLabel = props.options.find((option) => option.value === props.value)?.label ?? '';
  // @TODO: make keystrokes work (p -> go to pennsylvania)

  return (
    <FormControl
      label={props.label}
      disabled={props.disabled}
      isAlert={props.isAlert}
    >
      <View
        onLayout={(e) => setMenuWidth(e.nativeEvent.layout.width)}
        style={styles.menuContainer}
      >
        {!!_menuWidth &&
          <Menu
            style={styles.menuWrapper(_menuWidth)}
            contentStyle={styles.menuWrapperContent}
            visible={_isOpen}
            onDismiss={() => setIsOpen(false)}
            anchor={// @TODO: doesn't work if scrolled (same issue with tooltip)// @TODO: would also be nice to anchor directly below instead of on top of
              <TouchableRipple// @TODO: replace this with TextInput outlined to share styles (but make sure it doesn't double the formcontrols)
                onPress={() => setIsOpen(true)}
                style={styles.container}
                disabled={props.disabled}
              >
                <View style={styles.placeholderAndArrowWrapper}>
                  <Text style={styles.text}>{/* @TODO: or placeholder text if empty */}
                    {selectedLabel
                      ? selectedLabel
                      : <Text style={styles.placeholderText}>Select</Text>
                    }
                  </Text>
                  <Icon name='menu-down' style={styles.icon} />
                </View>
              </TouchableRipple>
            }
          >
            {props.options.map((option) => (
              <Menu.Item
                key={option.value}
                style={styles.menuItem}
                contentStyle={styles.menuItemContent}
                title={option.label}
                // @TODO: if currently selected, make bold
                onPress={() => {
                  props.onChange(option.value);
                  setIsOpen(false);
                }}
              />
            ))}
          </Menu>
        }
      </View>
    </FormControl>
  );
};

class SelectProps {
  label: string;
  options: Array<{
    label: string;
    value: string;
  }>;
  value: string;
  onChange: (value: string) => void;

  disabled?: boolean = false;
  isAlert?: boolean;
};

export default Select;
